import React from 'react';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

import PageContainer from 'components/PageContainer';
import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import SignIn from 'containers/SignIn';
import Footer from 'components/Footer';
import type { SignInDto } from 'state/signIn';

import useStyles from './SignInPage.style';

type SignInPageProps = {
  pending: boolean;
  signIn: (signInDto: SignInDto) => void;
};

const firstChildTopSpacing = 13; // 104px

const SignInPage: React.FC<SignInPageProps> = ({ signIn, pending }) => {
  const { container, signInFormContainer, sidebarLink } = useStyles({
    firstChildTopSpacing,
  });

  return (
    <PageContainer>
      <Header />
      <Grid container className={container}>
        <Hidden smDown>
          <Grid item sm={3} container>
            <Sidebar firstChildTopSpacing={firstChildTopSpacing}>
              <>
                <Typography variant="h1" component="div" color="textSecondary">
                  Perform simple,
                  <br />
                  secure migrations
                  <br />
                  with MigrationWiz.
                </Typography>
              </>
              <>
                <Typography variant="h4" component="div" color="textSecondary">
                  Leverage MigrationWiz for Teams Migrations
                </Typography>
                <Typography
                  variant="body1"
                  component="div"
                  color="textSecondary"
                >
                  Watch this on-demand webinar to learn more about Teams
                  migration best practices, pre-project planning considerations,
                  and see a short demo of the product in action.
                </Typography>
                <Link
                  href="https://now.bittitan.com/2021-lp-migrationwiz-microsoft-teams-migration-demo-v3.html"
                  variant="button"
                  underline="always"
                  className={sidebarLink}
                >
                  Watch Now
                </Link>
              </>
              <>
                <Typography variant="h4" component="div" color="textSecondary">
                  BitTitan Help Center
                </Typography>
                <Typography
                  variant="body1"
                  component="div"
                  color="textSecondary"
                >
                  Learn how to use our products, ask questions, and get fast
                  answers.
                </Typography>
                <Link
                  href="https://help.bittitan.com/hc/en-us"
                  variant="button"
                  underline="always"
                  className={sidebarLink}
                >
                  Visit the Help Center Today
                </Link>
              </>
            </Sidebar>
          </Grid>
        </Hidden>
        <Grid
          item
          sm={12}
          md={9}
          container
          direction="column"
          alignItems="center"
        >
          <Grid
            item
            container
            direction="column"
            className={signInFormContainer}
          >
            <SignIn signIn={signIn} pending={pending} />
          </Grid>
          <Grid item>
            <Footer />
          </Grid>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default SignInPage;
